var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"event-speaker-card__speaker mt-1 mb-2",style:({ background: _vm.cardBackground }),attrs:{"to":{
		name: 'speaker-by-id',
		params: {
			id: _vm.speaker.speaker_id,
		},
	}}},[_c('Avatar',{staticClass:"event-speaker-card__speaker-avatar",attrs:{"size":60,"avatar":_vm.speaker.speaker_logo}}),_c('p',{staticClass:"event-speaker-card__speaker-name"},[_vm._v(" "+_vm._s(_vm.speaker.speaker_name)+" ")]),_c('v-icon',{staticClass:"event-speaker-card__speaker-icon"},[_vm._v(" mdi-chevron-right ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }